<template>
  <v-container class="d-flex justify-center">
    <div class="trial-card2">
      <v-container>
        <v-row class="px-2">
          <v-col class="hidden-sm-and-down" cols="5">
            <div style="border-radius: 10px; background: #377DFF;">
              <v-img class="card-img" :src="trialImage"></v-img>
            </div>
          </v-col>
          <v-col>
            <div style="min-height: 190px">
              <h3>{{ trial.title }}</h3>
              <p class="mt-1">{{ trial.summary }}</p>
            </div>
            <v-divider class="mr-2 mb-1"></v-divider>
            <v-container>
              <v-row justify="space-between" class="pr-2">
                <p style="color: #5b5c5e">Location: {{ trial.Location }}</p>
                <v-btn
                  width="130px"
                  rounded
                  color="primary"
                  :to="`/trials/${trial.study_id}`"
                  elevation="0"
                  >Details</v-btn
                >
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!--<v-container class="trial-card pa-3">
      <v-row>
        <v-col cols="5" class="d-flex flex-column justify-center align-center">
          <v-avatar color="#f7f7f7" size="68">
            <v-avatar color="#cef0ff" size="54">
              <span class="primary&#45;&#45;text font-weight-bold">{{
                companyInitial
              }}</span>
            </v-avatar>
          </v-avatar>
          <div class="font-weight-bold title text-center mt-3 primary&#45;&#45;text">
            {{ trial.name }}
          </div>
          <span class="trial-card__underline mt-3"></span>
        </v-col>
        <v-col cols="7">
          <p style="height: 110px" class="text-xl-justify">
            {{ trial.summary[0] }}
          </p>
          <v-row justify="end">
            <v-btn
              rounded
              color="primary"
              class="mr-5"
              :to="`/trials/${trial.id}`"
              >Details</v-btn
            >
          </v-row>
        </v-col>
      </v-row>
    </v-container>-->
  </v-container>
</template>

<script>
export default {
  name: "TrialCard",
  props: {
    trial: {
      type: Object,
      required: true
    },
    trialImage: {
      type: String,
      default: require("@/assets/ad-trial/trials_image.jpg")
    }
  },
  created() {},
  computed: {
    companyInitial() {
      return this.trial.name.replace(/\W*(\w)\w*/g, "$1").toUpperCase();
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/_colors";

.trial-card2 {
  max-width: 1000px !important;
  //max-height: 350px !important;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.25) !important;
  border-radius: 10px !important;

  .card-img {
    max-width: 450px;
    height: 280px;
    background: #377dff;
    filter: blur(0.6px) brightness(120%);
    border-radius: 10px !important;
    opacity: 0.7;
  }
}
.trial-card {
  width: 500px;
  box-shadow: 2px 2px 4px rgba(91, 92, 94, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.125) !important;
  border-radius: 0.5rem;
}
.trial-card__underline {
  background-color: $primary;
  width: 100px;
  height: 2px;
  display: inline-block;
}
</style>
